import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import CreateEvent from "../../components/Shop/CreateSalesEvent";
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar';
import ShopManagementPageHero from '../../components/Shop/Layout/ShopManagementPageHero';

const ShopCreateEvents = () => {
  return (
    <div className="shop-management-page">
        <DashboardHeader />
        <div className="shop-management-layout">
      <div className="shop-management-sidebar-slot">
        <DashboardSideBar active={10} />
      </div>
      <main className="shop-management-main-panel">
        <ShopManagementPageHero
          eyebrow="Sales Events"
          title="Create Sale Event"
          copy="Set up sale pricing, dates, category details, and promotional imagery."
        />
        <CreateEvent />
      </main>
    </div>
    </div>
  )
}

export default ShopCreateEvents